const title = "尺度の大きさ（縦）と満足度との関係性の強さ（横）";
const categories = [
  { name: "1.会社への共感", color: "#a5b6d3" },
  { name: "2.労働時間管理・福利厚生", color: "#f79646" },
  { name: "3.評価・処遇", color: "#4bacc6" },
  { name: "4.給与", color: "#8064a2" },
  { name: "5.仕事の設計と配分", color: "#98b955" },
  { name: "6.上司の管理・監督", color: "#be4b48" },
  { name: "7.同僚との関係", color: "#40699c" },
  { name: "8.関連部署との関係", color: "#4a7ebb" },
  { name: "9.職場環境（物理的環境）", color: "#cc7b38" },
  { name: "10.仕事の充実", color: "#388ca2" },
  { name: "11.仕事の負荷", color: "#9786aa" },
  { name: "12.顧客との関係", color: "#7f9a48" },
  { name: "13.能力開発", color: "#9e413e" }
];

const makeSeries = (x, y) =>
  categories.map((v, i) => ({
    name: v.name,
    color: v.color,
    data: [
      {
        name: v.name,
        x: x[i],
        y: y[i],
        z: 1,
        color: v.color
      }
    ],
    sizeBy: "width",
    zMin: 1
  }));

const BubbleChart = (props) => ({
  chart: {
    type: "bubble",
    plotBorderWidth: 1,
    zoomType: "xy",
    height: 600
  },
  title: {
    text: props.title
  },
  xAxis: {
    gridLineWidth: 1,
    title: {
      text: props.xtitle
    },
    lebels: {
      format: `{point.y:.1f}`
    },
    tickInterval: 0.05
  },
  yAxis: {
    className: props.classes.verticalWriting,
    title: {
      text: props.ytitle,
      rotation: 0,
      useHTML: true,
      x: 36
    },
    labels: {
      rotation: -90
    },
    max: Math.ceil(Math.max(...props.ydata)) + 10,
    min: Math.floor(Math.min(...props.ydata)) - 10,
    tickInterval: 5
  },
  tooltip: {
    enabled: false
  },
  plotOptions: {
    series: {
      dataLabels: {
        enabled: true,
        allowOverlap: true,
        color: "#131516",
        format: `{point.name}`
      }
    }
  },
  series: makeSeries(props.xdata, props.ydata),
  legend: {
    layout: "vertical",
    align: "right",
    verticalAlign: "top",
    x: -40,
    y: 80,
    borderWidth: 1,
    shadow: true
  },
  credits: {
    enabled: false
  }
});

export default BubbleChart;



// WEBPACK FOOTER //
// ./src/models/BubbleChart.js